import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    marginTop: 24,
  },
  container: {
    marginTop: 4,
    marginBottom: 24,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: 36,
    '& .NumberValue-code, & .NumberValue-value': {
      lineHeight: 1,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 16,
    },
  },
  valueRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  currencyContainer: {
    marginBottom: 2,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
  sumBox: {
    display: 'block',
  },
  sumBoxTitle: {
    display: 'flex',
    gap: 4,
  },
  productsSummaryElements: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 24,
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: 33,
      rowGap: 16,
    },
  },
  productsSummaryElementsWithRowDivider: {
    [theme.breakpoints.down('sm')]: {
      rowGap: 33,
      '& > $summaryElement:nth-child(1)::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: -17,
        width: 'calc(200% + 33px)',
        height: 1,
        backgroundColor: theme.color.greys[15],
      },
    },
  },
  incomeWithIcon: {
    marginTop: 2,
    minHeight: 26,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  incomeLink: {
    width: 'fit-content',
  },
  label: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  },
  summaryElement: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      minWidth: 0,
      '&:nth-child(odd)::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: -17,
        width: 1,
        backgroundColor: theme.color.greys[15],
      },
    },
  },
  currencySkeleton: {
    [theme.breakpoints.down('sm')]: {
      backgroundColor: hexToRgbA(theme.color.constants.greys[0], 0.1)
    },
  },
}), { name: 'ProductIncomeSummary', index: StylesIndexInjections.UI_MOLECULES });
